export default {
  guestTitle: '登录 / 注册',
  guestDesc: '登录后解锁充值、返水、VIP、收藏等全部功能',
  copy: '复制',
  refreshBalance: '刷新余额',
  balanceRefreshed: '余额已刷新',
  deposit: '充值',
  withdraw: '提现',
  transfer: '额度转换',
  recover: '余额找回',
  vipTitle: 'VIP 俸禄特权',
  vipSub: '日 · 周 · 月俸禄,晋级领彩金',
  vipGo: '查看特权 ▶',
  vipGap: '距 V{level} 还需充值 {amt}',
  vipMax: '已达最高等级',

  rewardTitle: '奖励中心',
  rewardPending: '优惠 · 任务 · 返水 · 俸禄,{n} 个奖励待领取',
  rewardDone: '优惠 · 任务 · 返水 · 俸禄,今日奖励已领完',
  claim: '去领取',
  doTask: '去做任务',
  bets: '游戏报表',
  betOrders: '我的注单',
  betTotalStake: '下注总金额',
  betTotalWin: '中奖总金额',
  betCount: '下单注数',
  betStakeAmt: '下单金额',
  betWinAmt: '中奖金额',
  betViewDetail: '查看详情 ›',
  betEmpty: '该时段暂无投注',
  betLoading: '加载中…',
  betLoadMore: '加载更多',
  betNoMore: '没有更多了',
  betTime: '下注时间',
  betContent: '下注内容',
  betStatus: '订单状态',
  betOrderNo: '订单编号',
  betWon: '中奖',
  betLost: '未中奖',
  betPending: '待结算',
  betRefunded: '已退款',
  betTypeSlots: '电子',
  betTypeLive: '真人',
  betTypeSport: '体育',
  betTypeOriginal: '原创',
  betTypeChess: '棋牌',
  betTypeFish: '捕鱼',
  payout: '收款账户',
  security: '安全中心',
  securityOn: '已开启',
  kyc: '身份认证 KYC',
  kycNone: '未认证',
  kycPending: '审核中',
  kycRejected: '未通过',
  kycVerified: '已认证',
  refer: '推广赚钱',
  referTip: '佣金最高 25%',
  language: '语言 · Language',
  logout: '退出登录',
  logoutConfirm: '确认退出当前账号?余额与记录仍安全保存,重新登录即可查看。',
  cancel: '取消',
  langTitle: '选择语言',
  langComing: '即将上线',
  comingSoon: '功能即将开放',
  recoverScanning: '正在扫描场馆余额…',
  recoverEmpty: '各场馆暂无滞留余额',
  recoverOk: '已即时回收 {amt}',
  recoverTickets: '{n} 个场馆已转代位下分，后台处理中',
  recoverOkAndTickets: '已即时回收 {amt}，另有 {n} 个场馆代位处理中',

  // —— 额度转换 ——
  tfAuto: '自动额度转换',
  tfAutoDesc: '关闭后进场前手动转入所需额度,资金不整存三方',
  tfAutoAria: '自动额度转换开关',
  tfOut: '转出',
  tfIn: '转入',
  tfCentral: '中心钱包',
  tfVenue: '三方场馆',
  tfAvailable: '可用',
  tfVenueBal: '场馆余额',
  tfAmtPlaceholder: '自定义转换金额',
  tfAll: '全部',
  tfSelectVenue: '选择场馆',
  tfSearchVenue: '搜索场馆名称',
  tfAllCats: '全部',
  tfMaint: '维护中',
  tfPending: '代位下分中',
  tfMapped: '¥ 计价',
  tfEmptyVenue: '未找到相关场馆',
  tfLoading: '正在加载场馆…',
  tfUnknown: '--',
  tfNote:
    '单笔最低 {min} · 实时到账、免手续费 · 维护中场馆暂停转换;场馆余额无法转出时,可用「余额找回」一键代位下分。',
  tfConfirmIn: '确认转入 {name}',
  tfConfirmOut: '确认转出 {name}',
  tfBusy: '转换中…',
  tfMainAcct: '{code} 主账户',
  tfSwapAria: '切换转换方向',
  tfErrMaint: '{name} 维护中,暂停转换',
  tfErrPend: '{name} 代位下分处理中,暂不可转换',
  tfErrAmt: '请输入有效金额',
  tfErrMin: '单笔最低 {min}',
  tfErrCentral: '中心钱包可用不足(可转 {amt})',
  tfErrVenue: '{name} 场馆余额不足(可转 {amt})',
  tfErrUnknown: '{name} 场馆余额暂未查得,请稍后重试或使用余额找回',
  tfErrTimeout: '转换结果未知,请勿重复操作,稍后刷新余额确认',
  tfOkIn: '已转入 {name} {amt}',
  tfOkOut: '已从 {name} 转出 {amt}',
  tfAutoOn: '已开启自动额度转换:进入场馆自动携带余额',
  tfAutoOff: '已关闭自动转换:进场前请手动转入额度',
  tfEnterHint: '进入「{name}」:本场馆内计价符号为 ¥,= {code} 等值(1:1),进出等值可逆',

  // —— 消息通知 ——
  ntMarkAll: '全部已读',
  ntAllRead: '全部消息已读',
  ntEmpty: '暂无消息通知',
  ntLoading: '加载中…',
  ntNote: '最多保留最近 90 天站内消息；资金到账以钱包账变为准。',
  ntDetailTitle: '消息详情',
  ntKindFund: '资金通知',
  ntKindAct: '活动通知',
  ntKindSys: '系统通知',
  ntViewAria: '查看{title}',
  ntMissing: '消息不存在或已下架',
  ntTabAll: '全部',
  ntTabFund: '资金',
  ntTabAct: '活动',
  ntTabSys: '系统',
}
